export default __webpack_public_path__ + "static/media/480_dummy2016-fashion01-de.1dbd42d3.png";